import type { ReactElement } from "react";

import type { ICheckboxFilterOption } from "../../../components/filters/CheckboxFilter/types";
import type { CheckboxFilterModel } from "../../../models/CheckboxFilterModel";
import type { IFilterViewBaseProps } from "../../../types/filterInstance";

import { StyledCheckboxFilterContainer, StyledCheckboxFilterItem, StyledCheckboxFilterItemWrapper } from "./styles";

export const CheckboxFilter = <T extends string = string>({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<CheckboxFilterModel<T>>): ReactElement | null => {
    const handleTypeSelection = (selectedItem: T, isSelected: boolean) => () => {
        const currentValues = value ?? [];
        const updatedValues = isSelected
            ? currentValues.filter((v: T) => v !== selectedItem)
            : [...currentValues, selectedItem];

        onFilterUpdate(updatedValues);
    };

    const renderType = (option: ICheckboxFilterOption<T>) => {
        const isSelected: boolean = value?.includes(option.value) ?? false;

        return (
            <StyledCheckboxFilterItemWrapper key={option.label}>
                <StyledCheckboxFilterItem
                    selected={isSelected}
                    label={option.label}
                    onClick={handleTypeSelection(option.value, isSelected)}
                />
            </StyledCheckboxFilterItemWrapper>
        );
    };

    return (
        <StyledCheckboxFilterContainer>
            {filter.options.map((item: ICheckboxFilterOption<T>) => renderType(item))}
        </StyledCheckboxFilterContainer>
    );
};
